/**
 * "REACT_APP_" - обязательный префикс, чтобы CRA подхватывал переменные из .env файла
 * Например: REACT_APP_MY_VAR
 */

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';

export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV || '';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const INTERVIEW_VIEW_URL =
  process.env.REACT_APP_INTERVIEW_VIEW_URL || '';

export const ORIGIN_LINK = process.env.REACT_APP_ORIGIN_LINK || '';

export const KEYCLOAK_CLIENTID = process.env.REACT_APP_KEYCLOAK_CLIENTID || '';
